import { phpRequest } from "./phpRequest";

export const updateDeviceNubisVersionAPI = (deviceIds, nubisVersion) => {
  return phpRequest.put("/devices/nubis-version/update", {
    device_ids: deviceIds,
    nubis_version: nubisVersion,
  });
};
